// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__33cPO","title":"FrontImage_title__12JYf"};